module.exports = __webpack_public_path__ + "img/5-4.3f0da50e.svg";